document.querySelectorAll('.more-section-button--questions').forEach((button) => {
  button.addEventListener('click', (e) => {
    const blocks = document.querySelectorAll('.questions__item');
    const moreSectionBtn = e.currentTarget as HTMLElement;
    blocks.forEach((block) => {
      block.classList.remove('hidden');
    });
    moreSectionBtn.classList.add('hidden');
  });
});
